﻿import React, { useState, useEffect } from 'react';
import { IcGradient } from '../models/ic-gradient';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ToastProps } from '../models/toast-props';
import { EditType, MessageBoxReplyType, ModalMessageType } from '../models/enums';
import { MessageBoxReply } from '../models/message-box-reply';

import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';
import Guid from 'devextreme/core/guid';

import { ReactGrid, Id, CellChange, TextCell, Column, Row, Range, DefaultCellTypes } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";

let key = 0;

const GRADIENT_ID_COLUMN_IDX = 0;
const EDIT_TYPE_COLUMN_ID = "editType";
const UNSAVED_CHANGES_WARNING = 100;

const initColumns: Column[] = [
    { columnId: "gradientId", width: -20 },
    { columnId: EDIT_TYPE_COLUMN_ID, width: -20 },
    { columnId: "rowNumber", width: 120 },
    { columnId: "time", width: 250 },
    { columnId: "concentration", width: 250 },
    { columnId: "Dummy", width: 20 }
];

const headerRow: Row = {
    rowId: "header",
    cells: [
        { type: "header", text: "", className: "reactgrid-hidden-column" },
        { type: "header", text: "", className: "" },
        { type: "header", text: "Row Number", className: "reactgrid-header-cell" },
        { type: "header", text: "Time (min)", className: "reactgrid-header-cell" },
        { type: "header", text: "Concentration (mM)", className: "reactgrid-header-cell" },
        { type: "header", text: "" }
    ]
};

/*
gradientId ?: string;
benchSheetId ?: string;
rowNumber ?: number;
time ?: number;
concentration ?: number;
*/


export interface Props {
    benchSheetId?: string;
    onClose?: () => void;

    // gradients?: IcGradient[];
    //onGradientAdded?: (e: IcGradient) => void;
    //onGradientChanged?: (e: IcGradient) => void;
    //onGradientDeleted?: (e: any) => void;
    //readOnly?: boolean;
    //canDelete?: boolean;
}

export default function IcGradientsComponent(props: Props) {
    //let gradientsDatagridRef: any = useRef(null);

    const [gradients, setGradients] =
        useState<IcGradient[]>();

    const [rows, setRows] =
        useState<Row[]>();

    const [columns, setColumns] =
        useState<Column[]>(initColumns);

    const [selectedGradientId, setSelectedGradientId] =
        useState<string>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
        
    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getRows();
    }, [gradients]);

    key++;

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">
                    <Button text="Add Row" icon="plus" type="success"
                        className="pw-button" height='1.8rem'
                        hint="add row"
                        onClick={onAddRowClick} />

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button" height='1.8rem'
                        hint="save changes"
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button" height='1.8rem'
                        hint="close dialog"
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <ReactGrid
                    enableFillHandle={true}
                    enableRangeSelection={true}
                    rows={rows ? rows : []} columns={columns}
                    onSelectionChanging={onSelectionChanging}                    
                    onCellsChanged={handleChanges} />

                {/* onColumnResized = { handleColumnResize } */}
            </div>




            {/*
            <DataGrid ref={gradientsDatagridRef}
                height="100%"
                wordWrapEnabled={true}
                keyExpr="gradientId"
                dataSource={props.gradients ? props.gradients : []}
                showBorders={true}
                onRowValidating={onGradientsRowValidating} >

                <LoadPanel enabled={true} />

                <Selection mode={'single'} />

                <Column width={'5em'} caption="" cellRender={gradientInfoButtonTemplate} />

                <Column dataField={'rowNumber'} caption="" dataType="number" width={'3em'} allowEditing={false} />
                <Column dataField={'time'} caption="Time (min)" dataType="number" width={'40%'} />
                <Column dataField={'concentration'} caption="Concentration (mM)" dataType="number" width={'40%'} />

                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">Gradients</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem location="after" name="addRowButton" />
                </Toolbar>

                <Editing mode="cell"
                    useIcons={false}
                    allowAdding={!props.readOnly}
                    allowUpdating={!props.readOnly}
                    allowDeleting={false} />
            </DataGrid>
            

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }
            */}

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onReply={onGlobalDialogReply} onClose={onGlobalDialogClose} />
            }

        </div>
    );

    async function onSaveClick() {

        //todo - need to validate the UOMs etc


        const anyChanges = gradients.some(a => a.editType !== EditType.None);

        if (!anyChanges)
            return;

        await updateGradients(gradients)
            .then(() => {
                getGradients();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Gradients");
            });
    }

    function onCloseClick() {
        const anyNonSavedChanges = gradients.some(a => a.editType !== EditType.None);

        if (anyNonSavedChanges) {
            showPromptMessage(ModalMessageType.PromptYesNo,
                "Unsaved Items",
                "You have unsaved changes. Do you want to close anyway?",
                UNSAVED_CHANGES_WARNING);

            return;
        }

        closeDialog();
    }

    function closeDialog() {
        if (props.onClose)
            props.onClose();
    }

    function handleColumnResize(ci: Id, width: number) {
        if (!columns)
            return;

        setColumns((prevColumns) => {
            const columnIndex = prevColumns.findIndex(el => el.columnId === ci);
            const resizedColumn = prevColumns[columnIndex];
            const updatedColumn = { ...resizedColumn, width };
            prevColumns[columnIndex] = updatedColumn;
            return [...prevColumns];
        });
    }

    function onAddRowClick() {
        let rowNumber = 1;

        if (gradients)
            rowNumber = gradients.length + 1;

        let editedGradients = [...gradients];
        let newGradient: IcGradient = { gradientId: new Guid().toString(), rowNumber: rowNumber, editType: EditType.Insert };
        editedGradients.push(newGradient);

        setGradients(editedGradients);
    }

    function onSelectionChanging(selectedRanges: Range[]): boolean {
        //console.log("onSelectionChanging");
        //console.log(selectedRanges);

        if (selectedRanges && selectedRanges.length > 0 &&
            selectedRanges[0].columns && selectedRanges[0].columns.length > 0 &&
            selectedRanges[0].rows && selectedRanges[0].rows.length > 0) {

            //const rowId = selectedRanges[0].rows[0].rowId;

            //console.log("rowId:");
            //console.log(rowId);

            const selectedGradientCell = selectedRanges[0].first.row.cells[GRADIENT_ID_COLUMN_IDX] as any;
            const selectedGradientId = selectedGradientCell.text;

            //console.log("solventId:");
            //console.log(solventId);
            setSelectedGradientId(selectedGradientId);
        }

        return true;
    }

    function handleChanges(changes: CellChange<TextCell>[]) {
        setGradients((prevGradients) => applyChangesToGradients(changes, prevGradients));
    };

    function applyChangesToGradients(changes: CellChange<TextCell>[], prevGradients: IcGradient[]): IcGradient[] {
        //console.log("changes:");
        //console.log(changes);

        changes.forEach((change) => {
            const gradientIndex = change.rowId;
            const fieldName = change.columnId;

            prevGradients[gradientIndex][fieldName] = change.newCell.text;

            if (prevGradients[gradientIndex].editType !== EditType.Insert)
                prevGradients[gradientIndex].editType = EditType.Update;
        });

        return [...prevGradients];
    };


    /*
    function onGradientsRowValidating(e: any) {
        //update
        if (e.oldData && e.oldData.rowNumber) {
            let gradient = e.oldData as IcGradient;

            let updatedGradient = { ...gradient, ...e.newData };

            if (validateGradiant(updatedGradient)) {

                if (props.onGradientChanged)
                    props.onGradientChanged(updatedGradient);
            }
        }
        else { //insert
            if (e.newData) {

                let gradient = e.newData as IcGradient;

                if (validateGradiant(gradient)) {
                    if (gradient && props.gradients) {
                        const entriesCount = props.gradients.length;
                        gradient.rowNumber = entriesCount + 1;

                        if (props.onGradientAdded)
                            props.onGradientAdded(gradient);
                    }
                }
            }
        }
    }

    function validateGradiant(gradiant: IcGradient): boolean {
        //enforce time of 0 on Row 1
        if (!gradiant)
            return true;

        let rowNumber = gradiant.rowNumber ? gradiant.rowNumber : props.gradients && props.gradients.length + 1;

        if (rowNumber !== 1)
            return true;

        if (gradiant.time && gradiant.time !== 0) {
            if (gradientsDatagridRef && gradientsDatagridRef.current &&
                gradientsDatagridRef.current.instance) {

                gradientsDatagridRef.current.instance.cancelEditData();

                XXX.publish(ModalSubscriberTopic, {
                    modalType: InformationModal,
                    message: "The first Gradiant must have a time value of 0 (zero).",
                });

                return false;
            }
        }

        return true;
    }

    function onGradientsRowRemoving(e: any) {
        if (props.onGradientDeleted)
            props.onGradientDeleted(e);
    }
    
    function showInformationDialog(e: any) {
        if (props.gradients) {
            let entry = props.gradients.find(a => a.gradientId === e.key)

            if (entry) {
                let itemBasicInformation: ItemBasicInformation = {
                    rowPointer: entry.gradientId,
                    createTimestamp: entry.createTimestamp,
                    lastModifiedTimestamp: entry.modifyTimestamp,
                    createUser: entry.createUser,
                    modifyUser: entry.modifyUser
                };

                setItemBasicInformation(itemBasicInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }
    */


    // todo
    async function getGradients() {
        await CrudFunctions.getData(`benchsheets/icgradientsbybenchsheetid/${props.benchSheetId}`)
            .then((data) => {
                setGradients(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Gradients");
            });
    }

    async function updateGradients(editedGradients: IcGradient[]) {
        await CrudFunctions.putData("benchsheets/icgradients", editedGradients)
    }

    async function getAllData() {
        await getGradients();

    }

    function getRows() {
        let createdRows: Row[] = [];

        if (gradients) {
            createdRows = [
                headerRow,
                ...gradients.map<Row<DefaultCellTypes>>((gradient, idx) => ({
                    rowId: idx,
                    cells: [
                        { type: "text", text: gradient.gradientId ? gradient.gradientId : "", nonEditable: true, className: "reactgrid-hidden-column" },
                        { type: "text", text: "", nonEditable: true, className: getEditTypeTemplate(gradient) },
                        { type: "text", text: gradient.rowNumber ? gradient.rowNumber.toString() : "", className: "reactgrid-cell pw-bold reactgrid-horizontal-center" },
                        { type: "text", text: gradient.time ? gradient.time.toString() : "", className: "reactgrid-cell" },
                        { type: "text", text: gradient.concentration ? gradient.concentration.toString() : "", className: 'reactgrid-cell' },
                        { type: "text", text: "", nonEditable: true }

                    ]
                }))
            ];
            }
        else {
            let newGradients: IcGradient[] = [];
            newGradients.push({ gradientId: new Guid().toString(), rowNumber: 1, editType: EditType.Insert });

            setGradients(newGradients);
        }

        setRows(createdRows);
    }

    // show/hide
    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    //render

    function getEditTypeTemplate(gradient: IcGradient) {
        switch (gradient.editType) {
            case EditType.None:
                return "";
            case EditType.Insert:
                return "reactgrid-add-icon";
            case EditType.Update:
                return "reactgrid-edit-icon";
            case EditType.Delete:
                return "reactgrid-delete-icon";
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        if (reply.code === UNSAVED_CHANGES_WARNING) {
            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            closeDialog();
        }
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

